import { useQuery } from '@tanstack/react-query';

import { api } from './api.js';

import type { DashboardSummary } from '@aliashub/shared/dto';

export type {
  DashboardDailyPoint,
  DashboardKpi,
  DashboardRecentAlias,
  DashboardRecentMessage,
  DashboardStorage,
  DashboardSummary,
} from '@aliashub/shared/dto';

const KEY = ['dashboard', 'summary'] as const;

export function useDashboardSummary() {
  return useQuery<DashboardSummary>({
    queryKey: KEY,
    queryFn: () => api.get<DashboardSummary>('/api/v1/dashboard/summary'),
    staleTime: 60_000,
    refetchInterval: 60_000,
  });
}
